import {province as provinceList, city as cityList, area as areaList} from '@/util/address-data'
import { getEndDateToMonth } from 'tools'
import Vue from 'vue'

const dateFormat = function (date, fmt) {
    if (typeof date === 'number') {
        date = new Date(date);
    } else if (typeof date === 'string') {
        let d = new Date(date)
        if (d != 'Invalid Date') {
            date = d
        } else {
            date = new Date(date.replace(/-/g,'/'))
        }
    }
    if (!date) {
        return '';
    }

    fmt = fmt ? fmt : 'yyyy-MM-dd';

    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//计算某年指定月份的天数
const getDaysInOneMonth = function (year, month) {
    month = parseInt(month, 10);
    var d = new Date(year, month, 0);
    return d.getDate();
}
//当前日期加上一个月后是否超过下个月月末
const isBeyondNextMonth = function (date) {
    let nextMonthDate = new Date(date)
    nextMonthDate.setMonth(date.getMonth() + 1)
    return (date.getMonth() + 1) % 12 !== nextMonthDate.getMonth()
}
//获取下个月月末的时间
const getLastDateOfNextMonth = function (date) {
    let month = date.getMonth(),
        year = date.getFullYear(),
        nextMonth = month + 1
    return new Date(year, nextMonth, getDaysInOneMonth(year, nextMonth + 1))
}
//判断指定日期对应月份的天数在期间后的月份的天数是否存在
const hasDateAfterDuration = function (date, duration) {
    let _date = new Date(date)
    _date.setMonth(_date.getMonth() + duration)
    return date.getDate() === _date.getDate()
}
//计算对应保险期间的保险止期
const getValidEndDate = function (date, duration) {
    return new Date(getEndDateToMonth(date,duration))
    if (hasDateAfterDuration(date, duration)) {
        date.setMonth(date.getMonth() + duration)
    } else {
        for (let i = 0; i < duration; i++) {
            let bool = isBeyondNextMonth(date),
                monthDays = 0
            if (bool) {
                monthDays = date.getMonth() + 1
                date = getLastDateOfNextMonth(date)
            } else {
                date.setMonth(date.getMonth() + 1)
            }
        }
    }
    return date
}

/* Method of Boolean, Number, String*/
Boolean.prototype.clone = function() { return this.valueOf(); };
Number.prototype.clone = function() { return this.valueOf(); };
String.prototype.clone = function() { return this.valueOf(); };

/* Method of Date*/
Date.prototype.clone = function() { return new Date(this.valueOf()); };

/* Method of RegExp*/
RegExp.prototype.clone = function() {
    var pattern = this.valueOf();
    var flags = '';
    flags += pattern.global ? 'g' : '';
    flags += pattern.ignoreCase ? 'i' : '';
    flags += pattern.multiline ? 'm' : '';
    return new RegExp(pattern.source, flags);
};
function getVarType(data) {
    //确定当前变量的对象
    if (data === undefined) {
        return 'Undefined';
    }
    if (data === null) {
        return 'Null';
    }
    return Object.prototype.toString.call(data).slice(8, -1).toLowerCase();
};

function deepClone(data) {
    var objectType = getVarType(data);
    //the object for cloning is native object
    if (objectType == "null" || objectType == "undefined") {
        return data;
    }

    if (objectType == "string" || objectType == "number" || objectType == "boolean") {
        var copy = data;
        return copy;
    } else if (objectType == "date") {
        var copy = new Date();
        copy.setTime(data.getTime());
        return copy;
    } else if (objectType == "array") {
        var copy = [];
        for (var i = 0; i < data.length; i++) {
            copy[i] = deepClone(data[i]);
        }
        return copy;
    } else if (objectType == "object") {
        var copy = {};
        for (var attr in data) {
            if (data.hasOwnProperty(attr)) {
                copy[attr] = deepClone(data[attr]);
            }
        }
        return copy;
    }
}

function getAllUrlParam(url) {
    url = url === undefined ? window.location.href : url;
    url = url.indexOf('?') > -1 ? url.substring(url.indexOf('?') + 1, url.length) : '';
    var result = {};
    if (url) {
        let list = url.toString().split('&')
        for (let obj of list) {
            result[obj.split('=')[0]] = obj.split('=')[1];
        }
    }
    return result;
}

function getAreaData(p, c, d) {
    let po = {}, co = {}, ao = {}
    if (p && c) {
        po = provinceList.filter(function (item) {
            return item.code == p
        })[0];
        co = cityList.filter(function (item) {
            return item.code == c
        })[0]
        ao = areaList.filter(function (item) {
            return item.code == d
        })[0]
    }

    return {
        province: {
            code: po.code || '',
            name: po.name || ''
        },
        city: {
            code: co.code || '',
            name: co.name || ''
        },
        area: {
            code: (ao && ao.code) ? ao.code : '',
            name: (ao && ao.code) ? ao.name : ''
        }
    }
}

function numberToChinese(number) {
    const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
    const unit = ["", "十", "百", "千", "万"];
    let num = parseInt(number);
    let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
            newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
        }
        return newNum;
    }
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}

/**
 * 功能: 根据当前职业选项追溯职业名称
 * 参数: 职业列表(数组)，职业选项名称列表(数组)
 * 返回: {firstDes: '名称', secondDes: '名称', threeDes: '名称', val: '类别', code: ''}
 * let arr = Util.getAllProfessionDes(this.addressSearchList, [{jobDesc:"农作物种植者（不亲自作业）"}, {jobDesc:"农场经营者(不亲自作业)"}])
 * */
function getNode(json, nodeIds) {
  if (!Array.isArray(json) || !Array.isArray(nodeIds)) {
    return '参数有误！'
  }
  let nodes = [] //符合条件的node
  for (let nodeId of nodeIds) {
    for (let item of json) {
      if (nodes.length === nodeIds.length) {
        return nodes
      }
      for (let it of item) {
        if (!it || !it.des) {
          continue
        }
        if (it.des === nodeId.jobDesc || it.des === nodeId.des) {
          nodes.push(item)
          break
        }
      }
    }
  }
  return nodes
}
function getAllProfessionDes(json, nodeIds) {
  let origin = getNode(json, nodeIds)
  let res = []
  try {
    for (let node of origin) {
      let temp = {}
      temp.jobCode = node[2].code
      temp.jobClassifyInfo = `${node.map(item => item.des).join('_')}_${node[2].val}类`
      temp.jobMaxClassify = node[0].des
      res.push(temp)
    }
  } catch (error) {
    console.log(error)
    return res
  }
  return res
}

/**
 * 功能: 根据当前职业选项校验是否属于同一大类，同一类别的职业
 * 参数: 职业列表，比较职业选项名称(对象)，被比较的职业选项名称(对象)
 * 返回: true - 符合，false - 不符合
 * let bol = Util.checkProfessionCommon(this.addressSearchList, {jobDesc:"农作物种植者（不亲自作业）"}, {jobDesc:"农场经营者(不亲自作业)"})
 * */
function checkProfessionCommon(json, compare, compared) {
  if (!Array.isArray(json) && !compare && !compared) {
    return false
  }
  if (!compared.jobDesc) {
    return true
  }
  let tempCompareArr = [compare]
  let tempComparedArr = [compared]
  let compareTransformStr = getNode(json, tempCompareArr)
  let comparedTransformStr = getNode(json, tempComparedArr)
  if (!Array.isArray(compareTransformStr) || !Array.isArray(comparedTransformStr)) {
    return false
  }
  try {
    //地址大类和地址类别 完全相同
    if (compareTransformStr[0][0].des === comparedTransformStr[0][0].des && compareTransformStr[0][2].val === comparedTransformStr[0][2].val) {
      return true
    } else {
      return false
    }
  } catch (error) {
    console.log(error)
    return false
  }
}

function getCookie(name)
{
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); //正则匹配
    if(arr=document.cookie.match(reg)){
      return unescape(arr[2]);
    }
    else{
     return null;
    }
} 

function initWeiyiSDK ({ pageId, heartBeatRate = 5000, projectInfo = {}}) {
    // if (process.env.NODE_ENV === 'production') {
    window.WeiyiStatSDK.init({
      pageId,
      heartBeatRate,
      projectInfo,
      isProduct: process.env.NODE_ENV === 'production' ,
      Vue,
      name: 'insurance-group-pc',
      version: '1.0.0'
    })
    // }
}
function delEmptyParams(obj) {
    for (var pro in obj) {
      if (obj[pro] === '' || obj[pro] === undefined || obj[pro] === null) {
        delete obj[pro]
      }
    }
    return obj
}

function groupNameRule(val, unavailableGroupName, unavailableGroupNameMsg, ruleLength) {
    let clearName = val.replace(/\(|\)/g,'').replace(/\（|\）/g,'').replace(/\s*/g,"").replace(/\、|，|,|;|；/g, '').replace(/[A-Za-z]/g, '').replace(/\d/g, '')
    if (!val || !clearName) {
        return '请输入团体名称'
    }
    if (!/^([\u4E00-\u9FA5])*$/.test(clearName)) {
        return '团体名称格式校验错误，必须是纯中文 / 纯中文+(), 例如：xxx 或 xxx(xx)xx '
    }
    else if (val.length <= 3 && !ruleLength) {
        return '请根据证件上的团体名称正确填写，个体户/个人名称不允许投保'}
    else if (unavailableGroupName && unavailableGroupName.length > 0) {
        for (let name of unavailableGroupName) {
            if (val.indexOf(name) > -1) {
                return unavailableGroupNameMsg ? unavailableGroupNameMsg.replace(/\*/g, name) : '团体名称中不能包含"' + name + '"'
            }
        }
    } else if (!/^([\u4E00-\u9FA5])*$/.test(clearName)) {
        return '团体名称格式校验错误，必须是纯中文 / 纯中文+(), 例如：xxx 或 xxx(xx)xx '
    }
    return false
}

function durationKeysToDayjs(value) {
    const durationKeys = {
        'Y': 'year',
        'M': 'month',
        'D': 'day',
    }
    return durationKeys[value] || ''
}

function getJobType(val) {
    let jobType = ''
    for (let i = 0; i < 6; i++) {
        if (val == i + 1) {
            jobType += '1'
        } else {
            jobType += '0'
        }
    }
    return jobType
}

export default {
    getValidEndDate,
    dateFormat,
    deepClone,
    getAllUrlParam,
    getAreaData,
    numberToChinese,
    getNode,
    getAllProfessionDes,
    checkProfessionCommon,
    getCookie,
    initWeiyiSDK,
    delEmptyParams,
    groupNameRule,
    durationKeysToDayjs,
    getJobType
}



// WEBPACK FOOTER //
// ./src/util/util.js